/* eslint-disable @typescript-eslint/no-explicit-any */

import React, { useContext } from 'react'
import { useNavigate } from 'react-router-dom'

import { PAGE_TITLE } from '../../Configuration'
import usePageTitle from '../../hooks/use-page-title'
import { RoleContext } from '../../store/role-context-provider'
import { SelectionContextProvider } from '../../store/selection-context-provider'
import ArchivedInquiriesList from './archived-inquiries-list'

const ArchivedInquiries = () => {
  usePageTitle(PAGE_TITLE.ARCHIVED_INQUIRIES)
  const navigate = useNavigate()
  const { allMPF, isLoading } = useContext(RoleContext)
  if (!isLoading) {
    if (!allMPF) {
      navigate('/accessdenied')
    }
  }

  return (
    <SelectionContextProvider>
      <ArchivedInquiriesList />
    </SelectionContextProvider>
  )
}
export default ArchivedInquiries
